module.exports = __webpack_public_path__ + "static/vitalaccess-6699ca8dd5a1ad23bea614b866dcf32c.jpg";